import React from "react";
import "./Main.css";
import Heroimg from "../../assets/Heroimg.png";
import { NavLink } from "react-router-dom";

const Main = () => {
  return (
    <section className="hero">

      {/* Background image */}
      <div
        className="background-image"
        style={{ backgroundImage: `url(${Heroimg})` }}
      ></div>

      {/* Dark overlay */}
      <div className="background-overlay"></div>

      {/* Grid */}
      <div className="grid"></div>

      {/* Content */}
      <div className="hero-content">

        {/* Top heading */}
        <div className="top-heading">
          <span className="top-heading-span"><span className="check">✓ </span> Google Premier Partner</span>
          {/* <span>Google Premier Partner</span> */}
        </div>

        {/* Main heading */}
        <h1>
          #1 Google Ads Agency for
          <br />
           Local Businesses
        </h1>

        {/* Subtitle */}
        <p className="subtitle">
          We manage Google and Meta ads for home service businesses.
           $8.2M+ in spend managed, and every campaign measured against one number: cost per booked job.
        </p>

        {/* Buttons */}
        <div className="buttons">

        <a
  href="https://meetings-na2.hubspot.com/adwise-media?uuid=b5338f0a-6ee1-4e2b-88df-ab25699ff81c"
  className="btn primary"
  target="_blank"
  rel="noopener noreferrer"
>
  Book Consulting
</a>

          <NavLink to="/casestudies" className="btn secondary">
  See Client Results
</NavLink>

        </div>

        {/* Rating */}
        <div className="rating">
          <span>No contracts. Cancel with <strong>15 days</strong> notice.</span>
        </div>

      </div>

    </section>
  );
};

export default Main;